<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="text-center bg-gray-100">
          <b-row>
            <b-col>
              <img v-show="!file" v-if="items.image" width="100%" :src="items.image" />
              <img v-show="file" v-if="url" width="100%" height :src="url" />
            </b-col>
          </b-row>
          <input
            type="file"
            ref="file"
            style="display: none"
            v-validate="'image|minimalDimensions:1080,1002|size:2000|ext:jpg,png,gif,jpeg'"
            name="image"
            @change="onChangeFileUpload()"
          />
          <br />
          <b-link
            @click="$refs.file.click()"
            v-show="!file && !items.image"
            variant="primary"
            class="text-primary btn"
          >
            <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Icon Here
            <label class="text-danger">*</label>
          </b-link>
          <b-button
            @click="$refs.file.click()"
            v-show="file || items.image"
            variant="outline-primary"
            class
          >
            <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
          </b-button>
          <br />
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p>
          <p class="text-gray-500">
            Ukuran gambar 1080x1002 pixel
            File gambar harus berupa format JPEG, PNG, atau GIF
            Gambar tidak boleh melebihi 2MB
          </p>
        </b-card>
        <br />
        <label class="text-danger">
          *
          <b class="text-dark">Required</b>
        </label>
      </b-col>

      <b-col md="8">
        <b-row>
          <b-col md="6">
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Jumlah Rate"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="number"
                class="form-control"
                v-validate="'required|max:25'"
                name="jumlah"
                data-vv-as="Jumlah Rate"
                v-model="items.number_of_rates"
                placeholder="Jumlah Rate"
              />
              <b-form-invalid-feedback id="input-jumlah-feedback">{{ veeErrors.first('jumlah') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title Bahasa"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required|max:25'"
                name="title_id"
                data-vv-as="Title Bahasa"
                v-model="items.title.id"
                placeholder="Title Bahasa"
              />
              <b-form-invalid-feedback
                id="input-title_id-feedback"
              >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="input-group-1"
              class="required"
              label-class="control-label"
              label="Title English"
              label-for="input-1"
            >
              <input
                id="input-1"
                type="text"
                class="form-control"
                v-validate="'required|max:25'"
                name="title_en"
                data-vv-as="Title English"
                v-model="items.title.en"
                placeholder="Title"
              />
              <b-form-invalid-feedback
                id="input-title_en-feedback"
              >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-card
          header-bg-variant="transparent"
          body-class="pb-0"
          border-variant="secondary"
          align="left"
        >
          <b-row>
            <b-col class="text-left">
              <h6 class="text-primary">
                With Reason
                <img src="@/assets/ic-warning.svg" alt />
              </h6>
            </b-col>
            <b-col class="text-right">
              <b-form-checkbox
                v-model="items.is_with_reason"
                name="check-button"
                switch
              >{{items.is_with_reason === true ? 'Yes':'' || items.is_with_reason === false ? 'No':''}}</b-form-checkbox>
            </b-col>
          </b-row>
          <hr v-show="items.is_with_reason" />
          <b-card-body v-show="items.is_with_reason">
            <b-row>
              <b-col md="3">
                <b-form-group id="fieldset-1" label-class="mb-0" label-for="input-1">Reason</b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <vue-multiselect
                  v-model="items.reasons"
                  tag-placeholder="Add this as new tag"
                  placeholder="Search or add a Reason"
                  label="group_title"
                  track-by="id"
                  :options="reasonList"
                ></vue-multiselect>
              </b-col>
            </b-row>
            <b-row v-show="items.reasons.group_title != ''">
              <b-col>
                <hr />
                <h6>Detail Reason</h6>
                <ul>
                  <li v-for="(value, key) in items.reasons ? items.reasons.reasons:null" :key="key">
                    Reason {{key+1}}&nbsp;:
                    <ul>
                      <li>Bahasa : {{ value.reason_id }}</li>
                      <li>English : {{ value.reason_en }}</li>
                    </ul>
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <br />
        <b-row class="text-right">
          <b-col>
            <b-button variant="primary" @click="put()" :disabled="loading" class="mr-5">Save</b-button>
            <router-link :to="{name: 'Rate'}">
              <b-button variant="outline-secondary">Cancel</b-button>
            </router-link>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
  </div>
</template>

<script>
export default {
  props: ["items", "reasonList"],
  data() {
    return {
      reason: null,
      detail_reason: null,
      loading: false,
      is_with_reason: false,
      selected: "first",
      checked: false,
      modalShow: false,
      file: "",
      widthImage: null,
      heightImage: null,
      url: "",
      title_id: "",
      title_en: "",
      content_id: "",
      content_en: "",
      disabledDates: {
        to: new Date(Date.now() - 8672000)
      }
    };
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Rate!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              const formData = new FormData();
              formData.append("type", "lm");
              formData.append("title_id", this.items.title.id);
              formData.append("title_en", this.items.title.en);
              formData.append("number_of_rate", this.items.number_of_rates);
              formData.append("is_with_reason", this.items.is_with_reason);
              formData.append("image", this.file);
              if (this.items.is_with_reason == true) {
                formData.append("reason_id", this.items.reasons.id);
              } else {
                formData.append("reason_id", null);
              }

              this.loading = true;
              this.$store
                .dispatch("RatingModule/putRate", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "Rate" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
